import { useEffect, useRef } from "react";
import { trackDiagnostic } from "../../utils/diagnostics";
import { useVehiclesSocketStore } from "../../store/admin/vehiclesSocketStore";
import { useGroupsStore } from "../../store/admin/groupsStore";
import useIsMonitor from "../../hooks/useIsMonitor";
import {
  summarizeDeviceCompanies,
} from "./devicesDiagnostics";

const FILTERED_TO_ZERO_DELAY_MS = 8000;

export const useDevicesFilterDiagnostics = (visibleCount: number) => {
  const isInitialized = useVehiclesSocketStore((state) => state.isInitialized);
  const totalCount = useVehiclesSocketStore((state) => state.vehicles.length);
  const lastInitializedCompanyId = useVehiclesSocketStore(
    (state) => state.lastInitializedCompanyId,
  );
  const reportedKeyRef = useRef<string | null>(null);
  const hasUserFilters = useVehiclesSocketStore(
    (state) =>
      state.selectedGroup !== "all" ||
      !!state.selectedStatus ||
      !!state.debouncedSearchQuery.trim(),
  );
  const groupsLoading = useGroupsStore((state) => state.loading);
  const { isMonitor, devices: monitorDeviceIds } = useIsMonitor();

  const filteredToZero =
    isInitialized &&
    !groupsLoading &&
    !hasUserFilters &&
    totalCount > 0 &&
    visibleCount === 0;

  useEffect(() => {
    const reportKey = `${lastInitializedCompanyId}:${totalCount}`;
    if (!filteredToZero || reportedKeyRef.current === reportKey) return;
    const timer = setTimeout(() => {
      reportedKeyRef.current = reportKey;
      const { vehicles } = useVehiclesSocketStore.getState();
      const vehicleIds = new Set(vehicles.map((vehicle) => vehicle.id));
      const groups = useGroupsStore.getState().groups;
      trackDiagnostic("devices_filtered_to_zero", {
        reason: isMonitor ? "monitor_sin_asignados" : "compania_no_coincide",
        total_devices: vehicles.length,
        is_monitor: isMonitor,
        monitor_devices: monitorDeviceIds?.length ?? 0,
        monitor_devices_in_list: (monitorDeviceIds ?? []).filter((id: string) =>
          vehicleIds.has(id),
        ).length,
        groups_count: groups.length,
        ...summarizeDeviceCompanies(vehicles),
      });
    }, FILTERED_TO_ZERO_DELAY_MS);
    return () => clearTimeout(timer);
  }, [filteredToZero, lastInitializedCompanyId, totalCount, isMonitor, monitorDeviceIds]);
};
